import { Params, generatePath } from "react-router";

import { routes } from "../config/routes";

function getPath(routeKey: keyof typeof routes) {
  return routes[routeKey].split("?")[0];
}

function getRelativePath(from: keyof typeof routes, to: keyof typeof routes) {
  return getPath(to).replace(getPath(from).replace("/*", ""), "");
}

function getTo(routeKey: keyof typeof routes, params?: Params<string>) {
  return generatePath(routes[routeKey].replace("/*", ""), params);
}

export const router = { getPath, getRelativePath, getTo };
